import { frontendURL } from 'dashboard/helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import SoftphoneHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/softphone'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'softphone_settings_index',
          meta: {
            permissions: ['administrator'],
          },
          component: SoftphoneHome,
        },
      ],
    },
  ],
};
